import { render } from "./AddCates.vue?vue&type=template&id=fd2969fa&scoped=true"
import script from "./AddCates.vue?vue&type=script&lang=js"
export * from "./AddCates.vue?vue&type=script&lang=js"

import "./AddCates.vue?vue&type=style&index=0&id=fd2969fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2969fa"]])

export default __exports__